export const releaseVersion: string = '1.188.0';
